/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Globo Filter product card AJAX add-to-cart.
  // When the filter is active, Globo re-renders cards from its own cached
  // template (no local Liquid involved), so target `.spf-product__form` —
  // the Globo-exclusive class present in both server-render and filter-render.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.('.spf-product__form');
    if (!form) return;
    e.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.hasAttribute('disabled')) return;

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        bubbles: true,
        detail: { button },
      })
    );
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
